import React from 'react'

const About = () => {
  return (
    <div className='container mt-5 pt-5'>
      <div className="card mb-3 p-5 bg-dark ">
  {/* <img src="..." className="card-img-top" alt="..."/> */}
  <div className="card-body bg-dark">
    <h4 className="card-title text-warning">About Us</h4>
    <p className="card-text text-light">iNotebook app is one of the simplest and best free note-taking apps on mobile. It’s available on Android, iOS, and through your web browser. The app was rebranded to iNotebook app Notes at one point, but Google eventually went back to iNotebook app. If you are confused, don’t be. They are the same app.

It seems like a simple note-taking app on the surface. However, it has many fun little features and plenty of extras for your convenience. Let’s take a look at how to use iNotebook app. You can download the app to your Android device with the button below.</p>
    <p className="card-text text-primary"><small className="text-muted">copyright@2022 | All rights reserve</small></p>
  </div>
</div>
    </div>
  )
}

export default About
